/** @file Utilities for handling and getting attributes from html elements. */
import { Maybe } from '@codegrade/maybe';
/**
 * Return the fontweight, size and family of the element.
 *
 * @param el The html element to get the font from.
 * @returns The font string in the format {weight} {size} {family}.
 */
export function getCanvasFont(el) {
    let fontWeight = getComputedStyle(el).fontWeight;
    let fontSize = getComputedStyle(el).fontSize;
    let fontFamily = getComputedStyle(el).fontFamily;
    if (fontWeight === '') {
        fontWeight = 'normal';
    }
    if (fontSize === '') {
        fontSize = '16px';
    }
    if (fontFamily === '') {
        fontFamily = 'Times New Roman';
    }
    return `${fontWeight} ${fontSize} ${fontFamily}`;
}
/**
 * Get the width in pixels of the text if it were to be rendered on a canvas.
 * NOTE: That we always add an extra space to the text to make sure we overestimate.
 * We need this overestimation to ensure that we never assue that something fits,
 * when in reality it might not.
 *
 * @param text The text to measure the width of.
 * @param el The element that we want to render in, used to get the font.
 * @returns The width in pixels of the rendered text using a canvas.
 */
export function getTextWidthWithCanvasMeasureText(text, el) {
    const canvas = document.createElement('canvas');
    return Maybe.fromNullable(canvas.getContext('2d')).map(context => {
        context.font = getCanvasFont(el);
        const metrics = context.measureText(`${text} `);
        return metrics.width;
    });
}
